import { getS3Url } from "../../utilities/stamps-service";
import { sendS3Url } from "../../utilities/stamps-service";
import { useEffect, useState, useRef } from "react";
import useFirstRender from "../UseFirstRender/UseFirstRender";
import Loader from "../Loader/Loader";
import { FaImage } from "react-icons/fa";

export default function ImageForm({
  imageFormData,
  setImageFormData,
  imageUrl,
  setImageUrl,
}) {
  // below state has been moved to parent component
  // const [imageFormData, setImageFormData] = useState()
  // const [imageUrl, setImageUrl] = useState("")

  const firstRender = useFirstRender();
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!firstRender) {
      handleSubmit();
    }
  }, [imageFormData]);

  async function handleSubmit(evt) {
    // evt.preventDefault()
    try {
      setIsLoading(true);
      const { url } = await getS3Url(imageFormData.type);
      // console.log(url)
      setImageUrl(await sendS3Url(url, imageFormData));
      // console.log(imageUrl)
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  }

  function handleImageFormChange(evt) {
    if (evt.target.files && evt.target.files[0]) {
      setImageFormData(evt.target.files[0]);
      // console.log(evt.target.files[0])
    }
  }

  // console.log(imageFormData)
  // console.log(!!imageUrl)
  // console.log("imageurl", imageUrl)

  return (
    <section>
      <input
        ref={fileInputRef}
        type="file"
        name="image"
        accept="image/*"
        onChange={handleImageFormChange}
        className="hidden"
      />
      <button
        type="button"
        onClick={() => fileInputRef.current?.click()}
        className="inline-flex items-center gap-2 rounded-lg bg-teal-600 px-5 py-2.5 text-sm font-medium text-white shadow-sm transition-all hover:bg-teal-700 hover:shadow-md active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
      >
        <FaImage className="h-4 w-4" />
        {imageUrl ? "Change image" : "Upload image"}
      </button>
      {isLoading && (
        <div className="mt-3">
          <Loader />
        </div>
      )}
      {imageUrl && (
        <img
          className="mt-3 max-w-[250px] rounded-lg border border-gray-200 shadow-sm"
          src={imageUrl}
          alt=""
        />
      )}

      {/* <button onClick={handleSubmit}>upload</button> */}
    </section>
  );
}
